import { useQuery } from '@tanstack/react-query'
import { listFieldglassCompanyGroups } from 'api/admin/fieldglass/listFieldglassCompanyGroups'
import { fieldglassKeys } from './keys'

export const useFieldglassCompanyGroupsQuery = () => {
  return useQuery({
    queryKey: fieldglassKeys.companyGroups(),
    queryFn: listFieldglassCompanyGroups,
  })
}
